import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import useOnLoad from '~/routes/use-on-load';
import { useMemo, useState } from 'react';
import { SettingsCache } from '~/lib/consts/settings-cache';
import Loading from '~/components/loading/Loading';
import { GetQuoteServiceTagsFromItem } from '~/apps/smartsend/lib/helpers/SmartSendSummaryGenerator';
import ProviderGroupSummaryTotalVerified from '../actions/book/ProviderGroupSummaryTotalVerified';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { captureException } from '~/lib/metrics';

interface props {
  item: SmartSendItemApiModel;
  children: React.ReactNode;
}

const ItemBreakdown: React.FC<props> = (props) => {
  const { verifyShip } = useSmartSendApi();

  const preBookingVerification = useMemo(() => {
    return (
      SettingsCache.settings.Features.includes('PreBookingVerification') ||
      GetQuoteServiceTagsFromItem(props.item).includes('QuoteApi')
    );
  }, [props.item]);

  const [loading, setLoading] = useState(preBookingVerification);
  const [breakdown, setBreakdown] = useState<Record<string, number> | null>(null);

  useOnLoad(() => {
    const onLoad = async () => {
      try {
        const res = await verifyShip(props.item.Service.Provider, props.item.Service.AccountId, [props.item], null);
        setBreakdown(res?.result?.Breakdown ?? null);
      } catch (error) {
        // Log error. No need to do anything else, we'll just show the fallback breakdown if this fails.
        captureException(error, 'Error verifying provider group breakdown', {});
      } finally {
        setLoading(false);
      }
    };
    if (preBookingVerification) {
      onLoad();
    }
  });

  if (loading) {
    return <Loading />;
  }

  if (breakdown) {
    return <ProviderGroupSummaryTotalVerified breakdown={breakdown} currencyCode={props.item.CurrencyCode} />;
  }

  return <>{props.children}</>;
};

export default ItemBreakdown;
